import React from "react";
import _ from 'lodash';
import {withInfoListStyle} from 'module/PersonInfo/style/InfoListStyle';


export const PersonInfoList = withInfoListStyle(({models, classes}) => {
	return (
		<div className={classes.root}>
			{
				_.map(models, (msg, i) => (
					<div key={i} className={classes.msg} dangerouslySetInnerHTML={{__html: msg}}/>
				))
			}
		</div>
	);
});
